'use memo'
import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge'
import { getMissingDueDateText, getStepsCompletionInfo } from 'utils/tasks'

interface TaskDueCellProps {
  task: AutopilotTaskDto
}

const TaskDueCell = ({ task }: TaskDueCellProps) => {
  const { dueDate } = task

  const dueDateStr = dueDate as unknown as string
  const missingDateText = getMissingDueDateText(task)

  if (!dueDateStr && !missingDateText) return null
  const { latestCompletedDate } = getStepsCompletionInfo([task])

  return (
    <TaskDueDateBadge
      dueDate={dueDateStr}
      isCompleted={task.isCompleted ?? false}
      completedDate={latestCompletedDate}
      missingDateText={missingDateText}
    />
  )
}

export default TaskDueCell
